import type { MouseEvent } from 'react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from '@mui/material'

import { dataLayerPublish } from '@dhl/datalayer'
import { showPreferenceCentre } from './OneTrustHelpers.js'
import { useOneTrustContext } from './OneTrust.js'

interface CookiePreferenceResult {
  cookiePreferenceId: string
  cookiePreferenceText: string
  onCookiePreferenceButtonClick: (e: MouseEvent) => void
  showCookiePreferenceButton: boolean
}

export const useCookiePreferenceButton = (): CookiePreferenceResult => {
  const { t } = useTranslation()
  const {
    palette: { mode },
  } = useTheme()
  const { isOneTrustLoaded, nonce } = useOneTrustContext()

  const onCookiePreferenceButtonClick = useCallback(
    (e: MouseEvent) => {
      if (!isOneTrustLoaded) {
        return
      }

      e.preventDefault()
      e.stopPropagation()

      try {
        showPreferenceCentre({ nonce, enableDarkModeStyle: mode === 'dark' })
        window.OneTrust.ToggleInfoDisplay()
      } catch (err) {
        dataLayerPublish('ERROR', { id: 'one-trust', error: err, context: 'cookie-preference-button-click' })
      }
    },
    [isOneTrustLoaded, nonce, mode]
  )

  return {
    cookiePreferenceId: 'ot-sdk-btn',
    cookiePreferenceText: t('oneTrust.cookieButtonText'),
    onCookiePreferenceButtonClick,
    showCookiePreferenceButton: isOneTrustLoaded,
  }
}
